/**
 * Enhanced bot detection helper with debugging
 * Detects common web crawlers and bots based on user agent string
 */
export const detectBot = (): boolean => {
	if (typeof navigator === 'undefined') {
		console.log('Navigator undefined, assuming not bot')
		return false
	}

	const userAgent = navigator.userAgent || ''

	// More comprehensive bot detection
	const botPatterns = [
		'googlebot',
		'bingbot',
		'slurp',
		'crawler',
		'spider',
		'archiver',
		'facebookexternalhit',
		'twitterbot',
		'linkedinbot',
		'google',
		'bot',
		'crawl',
		'headless',
		'phantom',
		'automated',
	]

	const isBotDetected = botPatterns.some(pattern =>
		userAgent.toLowerCase().includes(pattern.toLowerCase())
	)

	return isBotDetected
}
